import { Type } from 'class-transformer';
import { Model } from './model';
import { EmailSender } from './email_sender';
import { EmailTemplate } from './email_template';
import { Partner } from './partner';
import { User } from './user';

export class BulkEmailRequest extends Model {
  @Type(() => User)
  requested_by: User | null;

  requested_by_id: string;

  @Type(() => EmailSender)
  email_sender: EmailSender | null;

  email_sender_id: string | null;

  @Type(() => EmailTemplate)
  email_template: EmailTemplate | null;

  email_template_id: string | null;

  @Type(() => Partner)
  partners: Partner[];
}
